import type React from "react";

import { Info } from "lucide-react";

import type { ScoreExplanation } from "../../types/scoreExplanation";
import { Dialog, DialogTrigger } from "../ui/Dialog";
import { ScoreExplanationDialog } from "./ScoreExplanationDialog";

interface ScoreExplanationTriggerProps {
  readonly explanation?: ScoreExplanation | null;
  readonly onOpportunityAction?: (actionRef: string) => void;
}

/** Opens the shared explanation dialog only when the report supplied an explanation. */
export function ScoreExplanationTrigger({
  explanation,
  onOpportunityAction,
}: ScoreExplanationTriggerProps): React.ReactElement | null {
  if (!explanation) return null;
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          type="button"
          className="rounded-md p-1 text-primary hover:bg-primary/10"
          aria-label={`Explain ${explanation.score_label} score ${explanation.score_value} out of ${explanation.score_max}`}
        >
          <Info className="h-4 w-4" />
          <span className="sr-only">Explain score</span>
        </button>
      </DialogTrigger>
      <ScoreExplanationDialog explanation={explanation} onOpportunityAction={onOpportunityAction} />
    </Dialog>
  );
}
